export default __webpack_public_path__ + "static/media/img_note2.131fd59b.png";